import React from 'react'
import { connect } from 'react-redux';
import { compose } from 'recompose'
import { selectElementFromId } from 'store/canvas/selectors'
import withRender from '../../renderer/utils/withRender'
import { getRouter } from '../../renderer/utils/withRouter'
import { getAssets } from '../../renderer/utils/withAssets'
import ElementSelector from './ElementSelector'
import ElementBar from '../components/ElementBar'

// accept componentId and then provide that component as props
// to WrappedComponent

const mapStateToProps = (state, props) => ({
  element: selectElementFromId(state, props),
});

const withComponentById = connect(mapStateToProps)

export default () => compose(
  withComponentById,
  getRouter(),
  getAssets(),
  withRender(ElementBar, ElementSelector),
)



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/core/withReduxElement.js